module.exports = __webpack_public_path__ + "img/official_accounts_website_2.7c673b1f.png";